/**
 * User: daletan
 * Date: 12/22/14
 * Time: 4:54 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var Backbone = require('dibs-backbone');
var RecentHistoryTitleView = require('./RecentHistoryTitleView');
var RecentHistoryListView = require('./RecentHistoryListView');
var targetEl = '#mainFacets';

module.exports = Backbone.BaseView.extend({
    className: 'recent-history-wrap',

    subViewConfig: {
        header: {
            singleton: true,
            construct: RecentHistoryTitleView,
        },
        list: {
            singleton: true,
            construct: RecentHistoryListView,
        },
    },

    initialize: function(options) {
        options = options || {};
        // vertical or horizontal, only vertical is used at the moment
        var orientationClass = 'is-' + (options.orientation || 'vertical');
        this.$el.addClass(orientationClass + ' facet-nav-content');
        this.subs.add({
            header: {},
            list: {
                collection: options.listCollection,
            },
        });

        if (options.targetEl) {
            targetEl = options.targetEl;
        }
    },

    render: function() {
        var $target = $(targetEl);
        if ($target.length) {
            this.subs.renderAppend(this.$el);
            this.$el.insertAfter($target);
        }
        return this;
    },
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/recentHistory/RecentHistoryWrapperView.js
// module id = 574
// module chunks = 7 8 9 10 11 21